var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        visible: _vm.visible,
        id: "admin-new-user-modal",
        title: "Add new User",
        "hide-footer": "",
        centered: "",
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "First Name" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", state: _vm.fieldValid("first_name") },
                model: {
                  value: _vm.formData.first_name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "first_name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.first_name",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("first_name") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.first_name) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Last Name" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", state: _vm.fieldValid("last_name") },
                model: {
                  value: _vm.formData.last_name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "last_name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.last_name",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("last_name") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.last_name) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Login" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", state: _vm.fieldValid("login") },
                model: {
                  value: _vm.formData.login,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "login",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.login",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("login") } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.formValidation.login) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Email" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", state: _vm.fieldValid("email") },
                model: {
                  value: _vm.formData.email,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "email",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.email",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("email") } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.formValidation.email) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Role" } },
            [
              _c("b-form-select", {
                attrs: {
                  options: _vm.availableRoles,
                  state: _vm.fieldValid("role"),
                },
                model: {
                  value: _vm.formData.role,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "role",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.role",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("role") } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.formValidation.role) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "slide" } }, [
            _vm.formData.role !== "admin"
              ? _c(
                  "div",
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Company" } },
                      [
                        _c("b-form-select", {
                          attrs: {
                            options: _vm.companies,
                            state: _vm.fieldValid("company"),
                          },
                          model: {
                            value: _vm.formData.company,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData,
                                "company",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "formData.company",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "b-form-invalid-feedback",
                          { attrs: { state: _vm.fieldValid("company") } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formValidation.company) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { attrs: { label: "User License" } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            type: "text",
                            state: _vm.fieldValid("user_license"),
                          },
                          model: {
                            value: _vm.formData.user_license,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData,
                                "user_license",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "formData.user_license",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "b-form-invalid-feedback",
                          { attrs: { state: _vm.fieldValid("user_license") } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formValidation.user_license) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { attrs: { label: "METRC API Key" } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            type: "text",
                            state: _vm.fieldValid("metrc_api_key"),
                          },
                          model: {
                            value: _vm.formData.metrc_api_key,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData,
                                "metrc_api_key",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "formData.metrc_api_key",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "b-form-invalid-feedback",
                          { attrs: { state: _vm.fieldValid("metrc_api_key") } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formValidation.metrc_api_key) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Password" } },
            [
              _c("b-form-input", {
                attrs: {
                  type: "password",
                  autocomplete: "new-password",
                  state: _vm.fieldValid("password"),
                },
                model: {
                  value: _vm.formData.password,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "password",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.password",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("password") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.password) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Confirm Password" } },
            [
              _c("b-form-input", {
                attrs: { type: "password", autocomplete: "new-password" },
                model: {
                  value: _vm.formData.password_confirmation,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "password_confirmation",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.password_confirmation",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                type: "submit",
                variant: "primary",
                disabled: _vm.formState.processing,
              },
            },
            [
              _vm._v("\n      Save new User\n      "),
              _vm.formState.processing
                ? _c("b-spinner", { staticClass: "ml-1", attrs: { small: "" } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              attrs: { type: "button", variant: "secondary" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }